module.exports = __webpack_public_path__ + "media/images/pc/top/area_brand_aqua@3x-019c0aec848e092fef225170e83c8664.webp";